import { useTranslation } from "react-i18next";

export function TestExpiredScreen() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-xl p-6 text-center">
      <h1 className="text-2xl font-semibold">{t("tests.public.expiredTitle")}</h1>
      <p className="mt-2 text-muted-foreground">{t("tests.public.expiredBody")}</p>
    </div>
  );
}
